var map = {
	"./Logo-BCH.png": 50906,
	"./Logo-BSV.png": 60222,
	"./Logo-Binance-Coin.png": 6013,
	"./Logo-Bitcoin.png": 59430,
	"./Logo-Btc-Lightning.png": 74331,
	"./Logo-Dash.png": 97319,
	"./Logo-EOS.png": 38337,
	"./Logo-Ether.png": 37067,
	"./Logo-Libra.png": 30832,
	"./Logo-Lightning.png": 87590,
	"./Logo-Litcoin.png": 74399,
	"./Logo-Litecoin.png": 46302,
	"./Logo-Tether.png": 20702,
	"./Logo-Travala.png": 1865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76603;